import { createSlice } from "@reduxjs/toolkit";
import { applyOrder } from "../actions/orderApplyAction";

const orderApplySlice = createSlice({
  name: "orderApply",
  initialState: {
    loading: false,
    error: null,
    result: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(applyOrder.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(applyOrder.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(applyOrder.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default orderApplySlice.reducer;
